import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IRootState } from "../../../../reducer/CombineReducer";
import { useUser } from "../../../../AuthContext";
import { GetVersioning } from "../CreateVersion/Scripts";
import { populateTableData } from "./helper";
import { VersionTableView } from "./VersionTable.view";
import { VersionEmptyState } from "./VersionEmptyState";

/**
 * Responsible for rendering the version table component
 */
export const VersionTable: React.FC = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const [
    extractState,
    versioning
  ] = useSelector((state: IRootState) => [
    state.extractState,
    state.versioning
  ], shallowEqual);
  const extractVersions = versioning?.versionList;
  const env = process.env.APP_TARGET_ENV as Environments;
  const extractGuid = extractState.selectedExtract?.extractGuid as string;
  const { user } = useUser();

  /**
   * Renders when versioning tab is clicked
   */
  React.useEffect (() => {
    GetVersioning(dispatch, translate, env, user?.token, extractGuid);
  }, [extractGuid]);

  return (
    <div className="ebt-version-table">
      {extractVersions && extractVersions.length > 0 &&
        <VersionTableView
          versionList=
            {
              populateTableData(
                extractVersions
              )
            }
        /> ||
        <VersionEmptyState />
      }
    </div>
  );
};
